import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client/api-client";
import {
  CHECK_TICKET_NUDGE,
  CREATE_GET_TICKET,
  GET_CONTACT_EMPLOYEES_BY_ROLE,
  GET_CONTACT_ROLES,
  GET_TICKET_AGENT_LIST,
  GET_TICKET_COUNTS,
} from "../../route/api.routes";

const config = {
  name: "tickets",
};
export const fetchTicketsList: any = createAsyncThunk(
  `${config.name}/fetchTicketsList`,
  async (params: any) => {
    return await Client.get(CREATE_GET_TICKET, { params });
  }
);
export const fetchTicketsAgentList: any = createAsyncThunk(
  `${config.name}/fetchTicketsAgentList`,
  async (params: any) => {
    return await Client.get(GET_TICKET_AGENT_LIST, { params });
  }
);
export const fetchTicketsListCount: any = createAsyncThunk(
  `${config.name}/fetchTicketsListCount`,
  async (params: any) => {
    return await Client.get(GET_TICKET_COUNTS, { params });
  }
);
export const getContactRoles: any = createAsyncThunk(
  `${config.name}/getContactRoles`,
  async () => {
    return await Client.get(GET_CONTACT_ROLES);
  }
);
export const getContactEmployeesByIds: any = createAsyncThunk(
  `${config.name}/getContactEmployeesByIds`,
  async (role_id: string) => {
    return await Client.get(GET_CONTACT_EMPLOYEES_BY_ROLE(role_id));
  }
);
export const createNewTicket: any = createAsyncThunk(
  `${config.name}/createNewTicket`,
  async (body: any) => {
    return await Client.post(CREATE_GET_TICKET, body);
  }
);
export const checkTicketNudge: any = createAsyncThunk(
  `${config.name}/checkTicketNudge`,
  async (body: any) => {
    return await Client.post(CHECK_TICKET_NUDGE, body);
  }
);
export const ticketsSlice = createSlice({
  name: config.name,
  initialState: {
    loading_tickets: false,
    tickets: [] as any,
    tickets_agents: [] as any,
    pagination: { offset: 0, limit: 10, total: 0 },
    error: "" as string,
    filters: null as any,
    sorters: {
      sort_column: "due_date",
      sort_val: null,
    } as any,
    contact_roles: [] as any,
  },
  reducers: {
    reset: (state) => {
      state.tickets = [];
      state.loading_tickets = false;
      state.pagination = { offset: 0, limit: 10, total: 0 };
      state.error = "";
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSorters: (state, action) => {
      state.sorters = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      //  Fetch Tickets
      .addCase(fetchTicketsList.pending, (state) => {
        state.loading_tickets = true;
        state.error = "";
      })
      .addCase(fetchTicketsList.fulfilled, (state, action) => {
        state.loading_tickets = false;
        state.tickets = action?.payload?.data?.data?.items;
        state.pagination = {
          offset: action?.payload?.data?.data?.offset,
          limit: action?.payload?.data?.data?.limit,
          total: action?.payload?.data?.data?.total,
        };
      })
      .addCase(fetchTicketsList.rejected, (state) => {
        state.loading_tickets = false;
        state.error = "";
      })
      .addCase(getContactRoles.pending, (state) => {
        // state.loading = true;
        state.error = "";
      })
      .addCase(getContactRoles.fulfilled, (state, action) => {
        // state.loading = false;
        state.contact_roles = action?.payload?.data?.data;
      })
      .addCase(getContactRoles.rejected, (state) => {
        // state.loading = false;
        state.error = "";
      });
  },
});

export const { setFilters, setSorters, reset } = ticketsSlice.actions;

export default ticketsSlice.reducer;
